import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/primitives";

const SECTIONS = [
    {
        h: "Information we collect",
        p: "We collect only the information you choose to share with us, such as your name, company, email and the operational details you provide when requesting an assessment.",
    },
    {
        h: "How we use it",
        p: "We use your information solely to respond to your enquiry, prepare your automation assessment and communicate with you about our work together.",
    },
    {
        h: "Data sharing",
        p: "We do not sell your data. We share information only with trusted providers who help us operate, and only to the extent necessary.",
    },
    {
        h: "Your rights",
        p: "You may request access to, correction of, or deletion of your personal information at any time by contacting us.",
    },
    {
        h: "Contact",
        p: "For any privacy questions, email support@harbrflow.com and we will respond promptly.",
    },
];

export default function Privacy() {
    return (
        <>
            <PageHeader
                eyebrow="Legal"
                titleLines={["Privacy Policy"]}
                description="How harbrflow handles the information you share with us."
            />
            <section className="py-20 md:py-28">
                <div className="mx-auto max-w-3xl px-6 lg:px-10">
                    <div className="space-y-12">
                        {SECTIONS.map((s) => (
                            <Reveal key={s.h}>
                                <div className="border-t border-border pt-6">
                                    <h2 className="text-2xl font-semibold tracking-tight">
                                        {s.h}
                                    </h2>
                                    <p className="mt-3 text-lg leading-relaxed text-muted-foreground">
                                        {s.p}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
